// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./global.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js!./card.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/gridstack/dist/gridstack.min.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
40: padding
16: padding
48: height
16: padding
*/

:host {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin: 4px;
  /*
  min-width: 1024px;
  min-height: 780px;
  */
}


/*
.grid-stack {
  border: 1px solid green;
}
.grid-stack > .grid-stack-item {
  border: 1px solid red;
}
.grid-stack > .grid-stack-item > .grid-stack-item-content {
  border: 1px solid blue;
}
*/


.subgrid.edit-mode-enabled {
  background: #eee;
}

.grid-header {
  display: flex;
  flex-grow: 0;
  height: 24px;
  /*background: var(--Colors-UI-Primary-Primary-Light, #D9ECFA);*/
  padding: var(--Spacings-Spacing-06, 1px);
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  height: auto !important;
  flex-wrap: wrap;
}

.grid-header.edit-mode-enabled {
  background: #d7d7d7;
  border-radius: var(--Radius-radius-l, 4px);
  cursor: pointer;
}

.grid-stack-item>.ui-resizable-se {
  cursor: pointer;
}


.grid-actions {
  display: flex;
  align-items: center;
  padding: 4px;
}

.gridstack-toolbar {
  align-self: flex-end;
  height: 25px;
  display: none;
  margin-right: 6px;
}

.gridstack-toolbar.edit-mode-enabled {
  display: unset;
}

.grid-toolbar {
  align-self: flex-end;
  height: 25px;
  display: none;
}

.grid-toolbar.edit-mode-enabled {
  display: unset;
}

.toolbar-action {
  gap: var(--Spacings-Spacing-03, 12px);
  cursor: pointer;
  font-weight: 600;
  user-select: none;
  display: inline;
  padding-left: 6px;
}

.toolbar-action:hover {
  color: var(--med-grey);
}

.toolbar-action:active {
  color: var(--light-grey);
}

.toolbar-img {
  height: 18px;
  width: 18px;
  opacity: 0.7;
  padding-top: 3px;
}

.toolbar-img:hover {
  opacity: 1.0;
}

.toolbar-img:active {
  opacity: 0.3;
}

.grid-body {
  display: flex;
  flex-grow: 1;
}






/*
.toolbar {
  display: flex;
  height: 30px;
  flex-shrink: 0;
}

.toolbar-action {
  padding: var(--Spacings-Spacing-06, 6px);
  cursor: pointer;
  font-weight: 600;
  user-select: none;
}
.toolbar-action:hover {
  color: var(--med-grey);
}
.toolbar-action:active {
  color: var(--light-grey);
}
*/

.grid-stack {
  height: 100%;
  width: 100%;
  /* margin: 0px; -- don't use styles here, use the gridstack options instead (ie: opts.marginRight) */
}

.grid-stack>.grid-stack-item>.grid-stack-item-content {
  margin: 20px;
}

.grid-stack>.grid-stack-item>.grid-stack-item-content>.subgrid>.grid-stack-item>.grid-stack-item-content {
  margin: 0px !important;
}

.grid-header-left,
.grid-header-right {
  display: flex;
  gap: 12px;
}

.grid-header-left {
  flex-direction: column;
  align-items: flex-start;
}

.grid-header-right {
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.toolbar-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  justify-content: flex-end;
}

.toolbar-row-stats {
  display: none;
  flex: 0 0 100%;
  justify-content: flex-start;
}

.grid-header.stats-left .toolbar-row-stats {
  display: flex;
}

.grid-header.stats-right .toolbar-row-stats {
  display: flex;
  justify-content: flex-end;
}



.tabbar-container {
  display: flex;
  flex-direction: row;
  gap: 32px;
  align-items: center;
  padding: 0px;
  height: 48px;
  justify-content: flex-start;
}
.tabbar-item {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: var(--Colors-UI-Neutral-Grey-500, #808080);
}
.tabbar-item:hover {
  font-weight: 700;
  color: var(--Colors-UI-Primary-Primary-Dark, #003252);
}
.tabbar-item:active {
  font-weight: 700;
  color: var(--Colors-UI-Primary-Primary-Dark, #003252);
}
.tabbar-item.selected {
  font-weight: 700;
  border-bottom: 4px solid var(--Colors-UI-Primary-Primary-Medium, #005D98);
  color: var(--Colors-UI-Primary-Primary-Dark, #003252);
}


#search {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 0;

  #search-text {
    position: relative;
    display: inline-block;
    background: white;
    color: #525252;
    font-size: 16px;
    font-weight: 400;
    border-radius: 16px;
    width: 240px !important;
    height: 46px !important;
    border: 1px solid #CCDCE4 !important;
    padding-left: 40px;
    box-sizing: border-box;
  }

  #search-text:focus {
    outline: none;
    /* Removes default outline */
    border: 1px solid rgb(204, 220, 228) !important;
    box-shadow: 0 0 5px rgba(204, 220, 228, 0.5);
  }
}

.search-wrapper {
  position: relative;
  display: inline-block;

}

#search-input {
  padding-left: 32px;
  /* space for the icon */
  height: 36px;
  position: relative;
  display: inline-block;
  background: white;
  color: rgb(82, 82, 82);
  font-size: 12px;
  font-weight: 400;
  width: 240px !important;
  height: 48px !important;
  border: 1px solid rgb(204, 220, 228) !important;
  border-radius: 12px;
}

.search-icon {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

`, "",{"version":3,"sources":["webpack://./src/gridstack.css"],"names":[],"mappings":"AAIA;;;;;CAKC;;AAED;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX;;;GAGC;AACH;;;AAGA;;;;;;;;;;CAUC;;;AAGD;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,+DAA+D;EAC/D,wCAAwC;EACxC,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;;;;;;AAOA;;;;;;;;;;;;;;;;;;;CAmBC;;AAED;EACE,YAAY;EACZ,WAAW;EACX,oGAAoG;AACtG;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;AACnD;AACA;EACE,gBAAgB;EAChB,qDAAqD;AACvD;AACA;EACE,gBAAgB;EAChB,qDAAqD;AACvD;AACA;EACE,gBAAgB;EAChB,yEAAyE;EACzE,qDAAqD;AACvD;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;;EAEd;IACE,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,oCAAoC;IACpC,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,4BAA4B;IAC5B,+CAA+C;IAC/C,4CAA4C;EAC9C;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;;AAEvB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;AACtB","sourcesContent":["@import url(\"./global.css\");\n@import url(\"./card.css\");\n@import url(\"~gridstack/dist/gridstack.min.css\");\n\n/*\n40: padding\n16: padding\n48: height\n16: padding\n*/\n\n:host {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  margin: 4px;\n  /*\n  min-width: 1024px;\n  min-height: 780px;\n  */\n}\n\n\n/*\n.grid-stack {\n  border: 1px solid green;\n}\n.grid-stack > .grid-stack-item {\n  border: 1px solid red;\n}\n.grid-stack > .grid-stack-item > .grid-stack-item-content {\n  border: 1px solid blue;\n}\n*/\n\n\n.subgrid.edit-mode-enabled {\n  background: #eee;\n}\n\n.grid-header {\n  display: flex;\n  flex-grow: 0;\n  height: 24px;\n  /*background: var(--Colors-UI-Primary-Primary-Light, #D9ECFA);*/\n  padding: var(--Spacings-Spacing-06, 1px);\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  height: auto !important;\n  flex-wrap: wrap;\n}\n\n.grid-header.edit-mode-enabled {\n  background: #d7d7d7;\n  border-radius: var(--Radius-radius-l, 4px);\n  cursor: pointer;\n}\n\n.grid-stack-item>.ui-resizable-se {\n  cursor: pointer;\n}\n\n\n.grid-actions {\n  display: flex;\n  align-items: center;\n  padding: 4px;\n}\n\n.gridstack-toolbar {\n  align-self: flex-end;\n  height: 25px;\n  display: none;\n  margin-right: 6px;\n}\n\n.gridstack-toolbar.edit-mode-enabled {\n  display: unset;\n}\n\n.grid-toolbar {\n  align-self: flex-end;\n  height: 25px;\n  display: none;\n}\n\n.grid-toolbar.edit-mode-enabled {\n  display: unset;\n}\n\n.toolbar-action {\n  gap: var(--Spacings-Spacing-03, 12px);\n  cursor: pointer;\n  font-weight: 600;\n  user-select: none;\n  display: inline;\n  padding-left: 6px;\n}\n\n.toolbar-action:hover {\n  color: var(--med-grey);\n}\n\n.toolbar-action:active {\n  color: var(--light-grey);\n}\n\n.toolbar-img {\n  height: 18px;\n  width: 18px;\n  opacity: 0.7;\n  padding-top: 3px;\n}\n\n.toolbar-img:hover {\n  opacity: 1.0;\n}\n\n.toolbar-img:active {\n  opacity: 0.3;\n}\n\n.grid-body {\n  display: flex;\n  flex-grow: 1;\n}\n\n\n\n\n\n\n/*\n.toolbar {\n  display: flex;\n  height: 30px;\n  flex-shrink: 0;\n}\n\n.toolbar-action {\n  padding: var(--Spacings-Spacing-06, 6px);\n  cursor: pointer;\n  font-weight: 600;\n  user-select: none;\n}\n.toolbar-action:hover {\n  color: var(--med-grey);\n}\n.toolbar-action:active {\n  color: var(--light-grey);\n}\n*/\n\n.grid-stack {\n  height: 100%;\n  width: 100%;\n  /* margin: 0px; -- don't use styles here, use the gridstack options instead (ie: opts.marginRight) */\n}\n\n.grid-stack>.grid-stack-item>.grid-stack-item-content {\n  margin: 20px;\n}\n\n.grid-stack>.grid-stack-item>.grid-stack-item-content>.subgrid>.grid-stack-item>.grid-stack-item-content {\n  margin: 0px !important;\n}\n\n.grid-header-left,\n.grid-header-right {\n  display: flex;\n  gap: 12px;\n}\n\n.grid-header-left {\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.grid-header-right {\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n}\n\n.toolbar-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  justify-content: flex-end;\n}\n\n.toolbar-row-stats {\n  display: none;\n  flex: 0 0 100%;\n  justify-content: flex-start;\n}\n\n.grid-header.stats-left .toolbar-row-stats {\n  display: flex;\n}\n\n.grid-header.stats-right .toolbar-row-stats {\n  display: flex;\n  justify-content: flex-end;\n}\n\n\n\n.tabbar-container {\n  display: flex;\n  flex-direction: row;\n  gap: 32px;\n  align-items: center;\n  padding: 0px;\n  height: 48px;\n  justify-content: flex-start;\n}\n.tabbar-item {\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  color: var(--Colors-UI-Neutral-Grey-500, #808080);\n}\n.tabbar-item:hover {\n  font-weight: 700;\n  color: var(--Colors-UI-Primary-Primary-Dark, #003252);\n}\n.tabbar-item:active {\n  font-weight: 700;\n  color: var(--Colors-UI-Primary-Primary-Dark, #003252);\n}\n.tabbar-item.selected {\n  font-weight: 700;\n  border-bottom: 4px solid var(--Colors-UI-Primary-Primary-Medium, #005D98);\n  color: var(--Colors-UI-Primary-Primary-Dark, #003252);\n}\n\n\n#search {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-left: 0;\n\n  #search-text {\n    position: relative;\n    display: inline-block;\n    background: white;\n    color: #525252;\n    font-size: 16px;\n    font-weight: 400;\n    border-radius: 16px;\n    width: 240px !important;\n    height: 46px !important;\n    border: 1px solid #CCDCE4 !important;\n    padding-left: 40px;\n    box-sizing: border-box;\n  }\n\n  #search-text:focus {\n    outline: none;\n    /* Removes default outline */\n    border: 1px solid rgb(204, 220, 228) !important;\n    box-shadow: 0 0 5px rgba(204, 220, 228, 0.5);\n  }\n}\n\n.search-wrapper {\n  position: relative;\n  display: inline-block;\n\n}\n\n#search-input {\n  padding-left: 32px;\n  /* space for the icon */\n  height: 36px;\n  position: relative;\n  display: inline-block;\n  background: white;\n  color: rgb(82, 82, 82);\n  font-size: 12px;\n  font-weight: 400;\n  width: 240px !important;\n  height: 48px !important;\n  border: 1px solid rgb(204, 220, 228) !important;\n  border-radius: 12px;\n}\n\n.search-icon {\n  position: absolute;\n  left: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
